"use client";

import { CustomButton, FlexCenter, FlexCol } from "@/components";
import ResultContent from "@/components/resultContent";
import { IBaseLabelValue } from "@/interfaces";
import {
  IRawPurchasedTaxRecordsInquiryResData,
  ITaxRecordItem,
} from "@/interfaces/inquiries/legal";
import { cn } from "@/lib";
import { routes } from "@/routes";
import { useRouter } from "next/navigation";

const formatValue = (value: unknown): string => {
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
};

const fieldLabels: Record<keyof ITaxRecordItem, string> = {
  name: "نام مودی",
  economicCode: "شماره اقتصادی",
  registrationStatus: "وضعیت ثبت نام",
  registrationStep: "مرحله ثبت نام",
};

const buildRecordContent = (record: ITaxRecordItem): IBaseLabelValue[] =>
  (Object.keys(fieldLabels) as (keyof ITaxRecordItem)[])
    .filter((key) => record[key] !== null && record[key] !== undefined)
    .map((key) => ({
      label: fieldLabels[key],
      value: formatValue(record[key]),
    }));

const TaxRecordsInquiryDetails = ({
  data,
}: {
  data: IRawPurchasedTaxRecordsInquiryResData;
}) => {
  const router = useRouter();
  const payload = data.data?.data;
  const records = Array.isArray(payload?.records) ? payload.records : [];
  const inquiryCode =
    data.data?.input?.inquiry_code ||
    (data as any)?.data?.input?.inquiryCode ||
    "-";

  const summary: IBaseLabelValue[] = [
    {
      label: "شماره ملی حقیقی / شناسه ملی حقوقی / شماره اقتصادی",
      value: inquiryCode,
    },
    {
      label: "تعداد پرونده های یافت شده",
      value: records.length.toLocaleString("fa-IR"),
    },
  ];

  return (
    <div className="shadow-main from-sunset-gold relative basis-[500px] rounded-2xl bg-linear-to-b to-transparent p-[2px] lg:basis-[760px]">
      <FlexCol className="items-stretch rounded-2xl bg-white p-6 sm:p-8">
        <h2 className="mb-8 text-center font-bold lg:text-lg">
          نتیجه استعلام پرونده های مالیاتی
        </h2>

        <ResultContent content={summary} />

        {records.length ? (
          <div className="mb-8 space-y-4">
            {records.map((record, index) => (
              <div
                key={`${record.economicCode || record.name || index}-${index}`}
                className="rounded-2xl border border-primary-main/15 bg-primary-main/5 p-4"
              >
                <h3 className="mb-4 font-semibold text-primary-main">
                  پرونده مالیاتی شماره {index + 1}
                </h3>
                <ResultContent
                  content={buildRecordContent(record)}
                  className="mb-0! shadow-none"
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="mb-8 rounded-2xl border border-amber-400/40 bg-amber-400/10 p-5 text-center text-sm leading-8 text-gray-800 sm:text-base">
            برای شماره وارد شده پرونده مالیاتی قابل نمایش یافت نشد.
          </div>
        )}

        <FlexCenter className="flex flex-col justify-center md:flex-row md:gap-6">
          <CustomButton
            id="details-tax-records-back"
            className={cn("w-fit bg-gray-500")}
            onClick={() => router.push(routes.main.INQUIRY_HISTORY.primaryPath)}
          >
            بازگشت
          </CustomButton>
          <CustomButton
            id="details-tax-records-new-request"
            onClick={() => router.push(routes.services.Tax_Records_Inquiry.rewritePath)}
            className={cn("bg-primary-main mx-auto w-fit px-8! text-white")}
          >
            استعلام جدید
          </CustomButton>
        </FlexCenter>
      </FlexCol>
    </div>
  );
};

export default TaxRecordsInquiryDetails;
